define([
	"dojo/_base/declare",
	"csi/def/Action",
	"csi/xml"
], function(declare, Action, xml) {

	return declare(null, {
		constructor: function(defAction) {
			this.m_action = defAction;
			this.m_id = defAction.m_id;
		},

		isAction: function() {
			return true;
		},

		disable: function(/*Boolean*/bEdit) {
			if (!bEdit) {
				this.m_action.m_right = this.m_action.m_rightParent = xml.RIGHT_NONE;
			}
		},

		getKey: function() {
			return this.m_action.getKey();
		},

		getAction: function(idAction) {
			return (this.m_id == idAction) ? this.m_action : null;
		},

		getQueryPath: function() {
			return this.m_action.m_path;
		},

		resolve: function(lmap, rcRoot, nodeRoot) {
			this.m_action.resolve(lmap, rcRoot, nodeRoot);
		},

		keyToHtml: function(/*Context*/ctx, /*DOMNode*/refNode) {
			this.m_action.toHtml(ctx, refNode);
		}
	});
});